import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Incognito({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M5.93756 8.99878L6.65886 4.66797C6.81993 3.70357 7.65528 2.99628 8.63269 2.99628H15.2464C16.2248 2.99628 17.0592 3.70357 17.2203 4.66797L17.9426 8.99878M10.2253 18.0025C10.2253 19.6601 8.88164 21.0038 7.2241 21.0038C5.56655 21.0038 4.22285 19.6601 4.22285 18.0025C4.22285 16.345 5.56655 15.0013 7.2241 15.0013C8.88164 15.0013 10.2253 16.345 10.2253 18.0025ZM10.2253 18.0025C11.1727 16.8591 12.7084 16.8591 13.6558 18.0025M13.6558 18.0025C13.6558 19.6601 14.9995 21.0038 16.657 21.0038C18.3146 21.0038 19.6583 19.6601 19.6583 18.0025C19.6583 16.345 18.3146 15.0013 16.657 15.0013C14.9995 15.0013 13.6558 16.345 13.6558 18.0025ZM2.99634 13.0004C7.96941 10.3323 16.0308 10.3323 21.0038 13.0004" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Incognito;